import { ControlCategories, ControlCategory } from "@theprelude/sdk";
import type { FC, SVGProps } from "react";
import { FirewallIcon } from "../icons/firewall-icon";
import { HelpIcon } from "../icons/help-icon";
import { MailIcon } from "../icons/mail-icon";
import { NetworkIcon } from "../icons/network-icon";
import { ScanIcon } from "../icons/scan-icon";
import { ServerIcon } from "../icons/server-icon";
import { ShieldFlash } from "../icons/shield-flash-icon";
import { ShieldIcon } from "../icons/shield-icon";
import { ShieldUser } from "../icons/shield-user-icon";

const ControlCategoryIcons: Record<
  ControlCategory,
  FC<Omit<SVGProps<SVGSVGElement>, "ref">>
> = {
  [ControlCategories.ASSET_MANAGER]: ServerIcon,
  [ControlCategories.CLOUD]: HelpIcon,
  [ControlCategories.DISCOVERED_DEVICES]: ScanIcon,
  [ControlCategories.EMAIL]: MailIcon,
  [ControlCategories.IDENTITY]: ShieldUser,
  [ControlCategories.INVALID]: HelpIcon,
  [ControlCategories.NETWORK]: NetworkIcon,
  [ControlCategories.PRIVATE_REPO]: ServerIcon,
  [ControlCategories.SIEM]: ServerIcon,
  [ControlCategories.XDR]: ShieldIcon,
  [ControlCategories.VULN_MANAGER]: ShieldFlash,
  [ControlCategories.HOST_FIREWALL]: FirewallIcon,
} as const;

export const ControlCategoryIcon: React.FC<
  React.SVGProps<SVGSVGElement> & { category: ControlCategory }
> = ({ category, ...props }) => {
  const Icon = ControlCategoryIcons[category];
  return <Icon {...props} />;
};
